import React, { useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import emailjs from '@emailjs/browser';

const About = () => {
  const form = useRef();
  const [showMessage, setShowMessage] = useState(false);

 
const sendEmail = (e) => {
  e.preventDefault();
  const btn = document.getElementById("button");
  btn.value = "Enviando...";

  // --- 1. Send email via EmailJS ---
  emailjs.sendForm(
      'service_a29n4ya',
      'template_0qwp1gb',
      form.current,
      'ZMdUwEUf5EG6H0nSS'
  )
  .then(() => {
      // --- 2. Reset form and show success message ---
      btn.value = "Enviar";
      form.current.reset();
      setShowMessage(true);
      setTimeout(() => {
          setShowMessage(false);
      }, 3000);
  }, (err) => {
      btn.value = "Enviar";
      alert(JSON.stringify(err));
  });
};
  return (
    <div>
      <Helmet>
        <title>Contacto | Manacars, Oyón (Álava)</title>
        <meta name="description" content="Contacta con Manacars por WhatsApp, teléfono o visítanos en Oyón, a 3 km de Logroño. Respondemos en menos de 24h." />
        <link rel="canonical" href="https://manacars.es/contacto" />
      </Helmet>
       {showMessage && (
        <div className="success-message">
          ¡Mensaje enviado con éxito!
        </div>
      )}
      <section >
      <section id="contact">
  <div class="contact-box">
    <div class="contact-links">
      <h2 className='contacttitle'>CONTACTO</h2>
      <p className="descriptioncontact">
          ¿Tienes dudas sobre algún vehículo o quieres visitarnos? Escríbenos por WhatsApp, llámanos o pásate por nuestras instalaciones en Oyón, a solo 3 km de Logroño. Respondemos en menos de 24 horas.
        </p>
        <div className="contact-details" style={{marginTop: "20px", color: "white"}}>
          <p><strong>Dirección:</strong> Carretera de Logroño, 4, Oyón (Álava), 01320</p>
          <p><strong>Email:</strong> info@manacars.es</p>
        </div>
        <picture>
          <source srcSet="/img/logo23.webp" type="image/webp" />
          <img src="/img/logo23.png" width="100" className='logoContact' alt="logo" />
        </picture>
    </div>
    <div class="contact-form-wrapper">
      <form ref={form} onSubmit={sendEmail}>
      <div className="form-group">
          <label for="to_name">Nombre</label>
          <input type="text" name="to_name" id="to_name" />
          </div>
        <div className="form-group">
          <label for="from_name">Email</label>
          <input type="email" name="email" id="from_name" />
          </div>
        <div className="form-group">
          <label for="message"></label>
          <textarea
            name="message"
            placeholder="Buenas,quisiera información sobre..."
            id="message_input"
            cols="30"
            rows="5"
            required
          ></textarea>
          </div>
        <input className="button submit-btn" type="submit" id="button" value="Enviar" />
      </form>
    </div>
  </div>
</section>
        </section>
    </div>
  )
}

export default About
